<div class="context-menu-header">
    <ng-content></ng-content>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/context-menu/context-menu-header.html